import React from "react";

export default function VerticalEnquiryButton() {
  return (
    <div
      style={{
        position: "fixed",
        right: "0px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 9999,
      }}
    >
        <a href="tel: +91 8509330871">
      <button
        style={{
          writingMode: "vertical-lr", // <-- changed for proper upright text
          textOrientation: "mixed",    // ensures letters are upright
          padding: "19px 7px",
          backgroundColor: "#c5a027",
          color: "#ffffff",
          borderRadius: "12px 0 0 12px",
          border: "none",
          cursor: "pointer",
          fontSize: "16px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
        }}
      >
        Helpline Number
      </button></a>
    </div>
  );
}
